export const config = {
  matchScoreThreshold: 75,
};
